export function scrollToElementWithOffset(element) {
    const headerHeight = parseInt(document.documentElement.dataset.headerHeight, 10) || 70
    const elementTop = element.getBoundingClientRect().top + window.scrollY
    const scrollPosition = elementTop - headerHeight

    window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth',
    })
}
